'use client';

import { __assign } from '../_virtual/_tslib.js';
import { ELanguage } from './constants.js';
import translations from './translations.js';

function validateEmail(email) {
    var regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
    return regExp.test(String(email).toLowerCase());
}
function validatePhoneNumber(phone) {
    var regExp = /^(\+|\(\+\d{1,2}\)\s?)?[\d,-,\s]{10,10}$/g;
    var validateResult = regExp.test(phone);
    if (!validateResult) {
        return false;
    }
    var filterZero = (phone.match(/0/g) || []).length;
    return filterZero < 8;
}
function validateUrl(text) {
    var url;
    try {
        url = new URL(text);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
}
function validateNoSpecialChars(text) {
    var NO_SPECIAL_CHARS = /[-0-9#@!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;
    return NO_SPECIAL_CHARS.test(text);
}
var validateVietNamPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
    return VN_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateI11lPhoneNumber = function (value) {
    var getPhoneNumber = value.split('-');
    var I11L_PHONE_NUMBER_REGEX = /^\d[0-9 ]{6,14}$/;
    return I11L_PHONE_NUMBER_REGEX.test(getPhoneNumber[1]);
};
var validateFormat = function (form, formRules, langCode) {
    var errors = __assign({}, form);
    for (var key in errors) {
        errors[key] = '';
    }
    var isValid = true;
    var t = function (key) {
        if (langCode === ELanguage.EN)
            return key;
        else
            return translations[key];
    };
    var _loop_1 = function (key, value) {
        var textValue = String(value);
        // validate requried
        if (formRules[key].errors.includes('required')) {
            if (!value) {
                errors[key] = t('This field is required.');
                isValid = false;
                return "continue";
            }
        }
        // validate range
        formRules[key].errors.some(function (error) {
            var _a;
            if (error.includes('char')) {
                var errorFormat = (_a = error.match(/[0-9-]/g)) === null || _a === void 0 ? void 0 : _a.join('');
                if (errorFormat === null || errorFormat === void 0 ? void 0 : errorFormat.includes('-')) {
                    var min = Number(errorFormat.split('-')[0]);
                    var max = Number(errorFormat.split('-')[1]);
                    if (textValue.length < min || textValue.length > max) {
                        errors[key] = t('Accept {0} characters.').replace('{0}', "".concat(min, " - ").concat(max));
                        isValid = false;
                        return true;
                    }
                }
                else {
                    var max = Number(errorFormat);
                    if (textValue.length > max) {
                        errors[key] = t('{0} characters limit.').replace('{0}', "".concat(max));
                    }
                }
            }
            return false;
        });
        if (errors[key])
            return "continue";
        // validate range number
        formRules[key].errors.some(function (error) {
            var _a;
            if (error.includes('number')) {
                var errorFormat = (_a = error.match(/[0-9-]/g)) === null || _a === void 0 ? void 0 : _a.join('');
                if (errorFormat === null || errorFormat === void 0 ? void 0 : errorFormat.includes('-')) {
                    var min = Number(errorFormat.split('-')[0]);
                    var max = Number(errorFormat.split('-')[1]);
                    if (textValue.length < min || textValue.length > max || !textValue.match(/^[0-9]*$/)) {
                        errors[key] = t('Accept {0} digits.').replace('{0}', "".concat(min, " - ").concat(max));
                        isValid = false;
                        return true;
                    }
                }
                else {
                    var max = Number(errorFormat);
                    if (textValue.length > max) {
                        errors[key] = t('{0} digits limit.').replace('{0}', "".concat(max));
                    }
                }
            }
            return false;
        });
        if (errors[key])
            return "continue";
        // validate email
        if (formRules[key].errors.includes('email')) {
            var isValidEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(textValue);
            if (textValue.length === 0 || textValue.indexOf('@') < 0 || textValue.indexOf('.') < 0 || !isValidEmail) {
                errors[key] = t('The Email must be a valid Email address.');
                isValid = false;
                return "continue";
            }
        }
    };
    for (var _i = 0, _a = Object.entries(form); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return { isValid: isValid, errors: errors };
};

export { validateEmail, validateFormat, validateI11lPhoneNumber, validateNoSpecialChars, validatePhoneNumber, validateUrl, validateVietNamPhoneNumber };
//# sourceMappingURL=validator.js.map
